<script>
import NextButton from 'dashboard/components-next/button/Button.vue';
// digitt: DENG-7201 — color dot or emoji marker
import LabelSwatch from 'dashboard/components-next/label/LabelSwatch.vue';

export default {
  components: {
    NextButton,
    LabelSwatch,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectLabel'],

  methods: {
    onClick() {
      this.$emit('selectLabel', this.title);
    },
  },
};
</script>

<template>
  <woot-dropdown-item>
    <NextButton
      slate
      ghost
      blue
      trailing-icon
      :icon="selected ? 'i-lucide-circle-check' : ''"
      class="w-full !px-2.5 justify-between"
      :class="{ '!flex-row': !selected }"
      @click="onClick"
    >
      <div class="flex items-center min-w-0 gap-2">
        <LabelSwatch
          v-if="color"
          :color="color"
          dot-class="size-3 rounded-full outline outline-1 outline-n-weak"
        />
        <span
          class="overflow-hidden text-ellipsis whitespace-nowrap leading-[1.1]"
          :title="title"
        >
          {{ title }}
        </span>
      </div>
    </NextButton>
  </woot-dropdown-item>
</template>
